import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function FlagStart(): React.ReactElement {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#finishIcon)">
        <path d="M7.59189 29.9744L8.1442 29.82C8.67544 29.6715 8.98575 29.1205 8.8373 28.5893L2.52266 5.9916C2.43356 5.6727 2.22141 5.40225 1.9329 5.23976C1.64438 5.07727 1.30314 5.03605 0.984231 5.12517L0.912903 5.14509C0.248779 5.33064 -0.13918 6.01944 0.0463687 6.68357L6.36116 29.2812C6.50961 29.8125 7.06062 30.1228 7.59189 29.9744Z"/>
        <path d="M29.8304 14.1825C27.8279 13.184 25.9754 11.9095 24.327 10.3963C24.1884 10.2695 24.1342 10.0748 24.1873 9.89457C25.0041 6.80467 25.6106 3.663 26.0028 0.491125C26.0649 -0.036461 25.7804 -0.191633 25.4804 0.170435C19.5942 7.21009 9.40973 -1.1175 3.34766 5.28078C3.42044 5.41705 3.47769 5.56105 3.51835 5.71009L7.6149 20.3791C13.6873 14.0584 23.8356 22.3342 29.7115 15.3101C30.0114 14.948 30.0683 14.286 29.8304 14.1825Z"/>
      </g>
      <defs>
        <clipPath id="finishIcon">
          <rect width="30" height="30"/>
        </clipPath>
      </defs>
    </svg>

  );
}
